export class FullscreenSlider {
    constructor(modalId) {
        var _a;
        this.id = modalId;
        this.modal = document.getElementById(modalId);
        if (!this.modal) {
            console.error(`Slider with ID "${modalId}" not found.`);
            return;
        }
        const closeSelectors = ['.fs-close', '[data-slider-close]'];
        this.closeButtons = (_a = this.modal) === null || _a === void 0 ? void 0 : _a.querySelectorAll(closeSelectors.join(','));
        this.initEvents();
    }
    initEvents() {
        var _a;
        try {
            (_a = this.closeButtons) === null || _a === void 0 ? void 0 : _a.forEach((e) => e.addEventListener('click', () => this.close()));
            this.modal.addEventListener('click', (event) => {
                if (event.target === this.modal) {
                    this.close();
                }
            });
            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && this.modal.classList.contains('open')) {
                    this.close();
                }
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    open(slideIndex) {
        try {
            this.modal.classList.add('open');
            document.body.classList.add('no-scroll');
        }
        catch (e) {
        }
    }
    close() {
        try {
            this.modal.classList.remove('open');
            document.body.classList.remove('no-scroll');
        }
        catch (_a) {
            console.log('asdasd');
        }
    }
}
